<div class="breadcrumb">
  <div class="home hover-nudge" routerLink="/">
    <svg style="width: 30px; height: 30px; color: inherit;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.78 15.77"><path fill="white" class="cls-1" d="M15.66,7.6,8.17.12A.38.38,0,0,0,7.89,0a.36.36,0,0,0-.28.12L.12,7.6a.4.4,0,0,0,.28.69H1.87v7.09a.39.39,0,0,0,.4.39H6a.39.39,0,0,0,.4-.39V11.63a1.47,1.47,0,1,1,2.94,0v3.75a.39.39,0,0,0,.4.39H13.5a.39.39,0,0,0,.4-.39V8.29h1.48A.41.41,0,0,0,15.75,8a.42.42,0,0,0-.09-.44ZM13.5,7.49a.4.4,0,0,0-.4.4V15H10.16V11.63a2.27,2.27,0,1,0-4.54,0V15H2.67V7.89a.4.4,0,0,0-.4-.4h-.9L7.89,1l6.52,6.53Z"/></svg>
  </div>

  <ng-container *ngIf="activeClient">
    <div class="divider"><span>/</span></div>

    <div class="item"
         [routerLink]="'/bewind/'+activeClient.id"
         [attr.data-is-navigable]="activeAccount != null || activeReport != null || currentPage != null"
         [attr.data-has-dropdown]="clients.length > 1">
      {{activeClient.name}}
      <ng-container *ngIf="clients.length > 1">
        <div class="dropdown-trigger" (click)="$event.stopPropagation()" [matMenuTriggerFor]="clientsMenu">
          <span class="material-icons">arrow_drop_down</span>
        </div>

        <mat-menu #clientsMenu="matMenu" xPosition="before" yPosition="below">
          <ng-container *ngFor="let listItem of clients">
            <button mat-menu-item [disabled]="listItem == activeClient"  [routerLink]="'/bewind/'+listItem.id">
              {{listItem.name}}
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </ng-container>


  <ng-container *ngIf="activeAccount">
    <div class="divider hide-on-phone"><span>/</span></div>

    <div class="item hide-on-phone"
         [attr.data-is-navigable]="false"
         [attr.data-has-dropdown]="accounts.length > 1">
      {{activeAccount.name}}

      <ng-container *ngIf="accounts.length > 1">
        <div class="dropdown-trigger" [matMenuTriggerFor]="menu">
          <span class="material-icons">arrow_drop_down</span>
        </div>

        <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
          <ng-container *ngFor="let listItem of accounts">
          <button mat-menu-item [disabled]="listItem == activeAccount" [routerLink]="'/rekening/'+listItem.id">
            {{listItem.name}}
          </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="activeReport">
    <div class="divider hide-on-phone"><span>/</span></div>

    <div class="item hide-on-phone"
         [attr.data-is-navigable]="false"
         [attr.data-has-dropdown]="reports.length > 1">
      {{ reportService.getReportName(activeReport.code) }} {{ activeReport.year }}

      <ng-container *ngIf="reports.length > 1">
        <div class="dropdown-trigger" [matMenuTriggerFor]="menu">
          <span class="material-icons">arrow_drop_down</span>
        </div>

        <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
          <ng-container *ngFor="let listItem of reports">
            <button mat-menu-item [disabled]="listItem == activeReport" (click)="toReport(listItem)">
              {{ reportService.getReportName(listItem.code)}} {{listItem.year }}
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="currentPage">
    <div class="divider"><span>/</span></div>
    <div class="item" data-is-navigable=false>{{currentPage}}</div>
  </ng-container>

  <div class="clearFix"></div>
</div>
